<template>
  <v-card flat>
    <v-container>
    <p>{{shop.id}}</p>
    <v-form ref="form" v-model="form.valid">
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">店名</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.name"
            :rules="[rules.max50]"
            style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">住所</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.address"
            :rules="[rules.max500]"
            style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">都道府県</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.pref"
            :rules="[rules.max50]"
            style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">人気商品</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.pickMenu"
            :rules="[rules.max50]"
            style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">説明文</v-flex>
        <v-flex xs12>
          <v-textarea
            v-model="form.description"
            :rules="[rules.max500]"
            style="padding-top:0;" rows="10"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex xs12>
          <v-btn @click="sendForm()" block dark large color="primary">
            <div v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <span v-else>登録する</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    </v-container>
  </v-card>
</template>

<script>
import { db } from '@/main'
// @ is an alias to /src
export default {
  name: 'ShopForm',
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        description: '',
        address: '',
        pref: '',
        pickMenu: ''
      },
      rules: {
        required: v => !!v || '必須項目です。',
        max50: v => {
          return v.length <= 50 || '入力できるのは50文字までです。'
        },
        max500: v => {
          return v.length <= 500 || '入力できるのは500文字までです。'
        }
      }
    }
  },
  props: {
    shop: Object
  },
  created () {
    if (this.shop.form) {
      this.form = this.shop.form
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    async sendForm () {
      await db.collection('shops').doc(this.shop.id).set({form: this.form}, {merge: true})
      let obj = {
        group: 'messageBottom',
        type: 'success',
        text: '更新しました。'
      }
      this.$emit('onMessage', obj)
    }
  },
  components: {
  }
}
</script>

<style scoped>
.formBlock {
  margin-bottom:10px;
}
/* The input */
.formElementLabel {
  text-align: left;
  color:#888;
}
</style>